module.exports = __webpack_public_path__ + "static/media/apple-store-badge.e6ec7f8a.svg";